<template>
<div>
  <div class="wistia_embed wistia_async_6r61gdb0hh">
    &nbsp;
  </div>

  <div
    id="uhc_colon_cancer_choose"
    class="tbk-vid-embed"
  >
    <a
      id="FIT"
      class="embedded_video"
      href="#wistia_zxulms5fy8?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="cologuard"
      class="embedded_video"
      href="#wistia_fp8fvr6tji?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="colonoscopy"
      class="embedded_video"
      href="#wistia_7y1slo0wod?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('6r6', 85, this.showSelect)

    this.tbk.loadCrossTime('7y1', 245, this.showSelect)
    this.tbk.loadCrossTime('zxu', 149, this.showSelect)
    this.tbk.loadCrossTime('fp8', 185, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        '7y1': this.tbk.autoPlay,
        zxu: this.tbk.autoPlay,
        fp8: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#uhc_colon_cancer_choose
  display: none
  a
    text-decoration: none
#FIT
  position: absolute
  top: 0
  left: 0
  width: calc(100% / 3)
  height: 100%
#cologuard
  position: absolute
  top: 0
  left: calc(100% / 3)
  width: calc(100% / 3)
  height: 100%
#colonoscopy
  position: absolute
  top: 0
  left: calc(200% / 3)
  width: calc(100% / 3)
  height: 100%
</style>
